export default __webpack_public_path__ + "static/media/section1_footer_bg.f93255e7.png";